import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import * as Sentry from "@sentry/remix";

declare global {
  interface Window {
    ENV?: {
      NODE_ENV?: string;
    };
  }
}
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/docs/en/main/file-conventions/entry.client
 */

import { StrictMode, startTransition, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";


Sentry.init({
  environment: window.ENV?.NODE_ENV ?? 'development',
  dsn: "https://ceb82c8a83b034bdae745ed6ce75ca52@o183191.ingest.us.sentry.io/4506852541136896",
  tracesSampleRate: 0.02,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.replayIntegration(),
  ],
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
